import { Nav, Navbar } from "@rebootui";
import { Link } from "react-router-dom";
import logoUrl from "../../assets/images/logo.svg";
import { siteNavLinks } from "../../data/siteNavLinks";

const Header = () => {
    return (
        <div className="p-2 px-4 bg-body-tertiary">
            <Navbar className="navbar-expand-lg bg-body-tertiary w-100 py-0" >
                <Navbar.Brand>
                    <Link to="/" className="navbar-brand d-flex align-items-center gap-s">
                        <img src={logoUrl} alt="logo" className="logo" style={{ height: "40px" }} />
                    </Link>
                </Navbar.Brand>
                {/* {sidebar && (
                    <Button
                        type="button"
                        className="btn btn-link text-dark p-2 me-1 d-flex align-items-center"
                        onClick={sidebar.toggleSidebar}
                        aria-expanded={sidebar.sidebarOpen}
                        aria-label={
                            sidebar.sidebarOpen
                                ? "Hide documentation sidebar"
                                : "Show documentation sidebar"
                        }
                    >
                        <Icon name="bars" width={22} height={22} />
                    </Button>
                )} */}
                <Navbar.Toggle />
                <Navbar.Collapse>
                    <Nav className="me-auto">
                        {siteNavLinks.map((navlink) => (
                            <Nav.Item key={navlink.url}>
                                <Nav.Link as={Link} to={navlink.url}>
                                    {navlink.name}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
};

export default Header;
